import { Injectable } from '@angular/core';
import { en } from '../../../environments/environment.tok'
import * as forge from 'node-forge';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MakingDataService {

  constructor() {

  }

  // async dataE(data: any) {
  //   let k=en.temppu.substring(1,en.temppu.length-1)
  //   const pK = forge.pki.publicKeyFromPem(k.split('\\n').join('\n'));
  //   let chunkSize = 214
  //   const chunks: any = [];
  //   let dataToencrypt = data instanceof  String ? data:JSON.stringify(data)

  //   for (let i = 0; i < dataToencrypt.length; i += chunkSize) {
  //     const chunk = dataToencrypt.substring(i, i + chunkSize);
  //     const encryptedChunk = pK.encrypt(chunk, 'RSA-OAEP')
  //     chunks.push(JSON.stringify(encryptedChunk));
  //   }
  //   return forge.util.encode64(JSON.stringify(chunks))

  // }

  // async dataD(data: any) {
  //   let k=en.temppa.substring(1,en.temppa.length-1)
  //   const pK = forge.pki.privateKeyFromPem(k.split('\\n').join('\n'));
  //   let dataToEncrypt = forge.util.decode64(data['data'])
  //   let decryptedData = '';
  //   for (let encryptedChunk of JSON.parse(dataToEncrypt)) {
  //     const decryptedChunk = pK.decrypt(JSON.parse(encryptedChunk), 'RSA-OAEP');
  //     decryptedData += decryptedChunk;
  //   }
  //   if (data['error'] == false) { 
  //     try{
  //       data['data'] = JSON.parse(decryptedData) 
  //     }catch(error){
  //       data['data']=decryptedData
  //     }
  //   }else {
  //     data['data'] = decryptedData
  //   }
  //   return data

  // }



  async dataE(data: any) {
    try {
      let k = en.temppu;
      // Robust quote stripping
      if (k.startsWith('"') || k.startsWith("'")) {
        k = k.substring(1, k.length - 1);
      }

      const pemString = k.split('\\n').join('\n');
      if (!pemString.includes('BEGIN PUBLIC KEY')) {
        throw new Error("Invalid Public Key format. Key might still be encrypted or corrupted.");
      }

      const pK = forge.pki.publicKeyFromPem(pemString);

      // Convert to UTF-8 bytes
      let dataToEncrypt = (typeof data === 'string') ? data : JSON.stringify(data);
      const bytes = forge.util.encodeUtf8(dataToEncrypt);

      // RSA max data size per chunk = key_size_in_bytes - padding_overhead
      // For 2048-bit key and OAEP, max is ~214 bytes
      const chunkSize = 214;
      const chunks: string[] = [];

      for (let i = 0; i < bytes.length; i += chunkSize) {
        const chunk = bytes.substring(i, i + chunkSize);
        const encryptedChunk = pK.encrypt(chunk, 'RSA-OAEP');
        chunks.push(encryptedChunk); // don't JSON.stringify here
      }

      // Encode as base64 for transfer
      return forge.util.encode64(JSON.stringify(chunks));
    } catch (error) {
      console.log(error);
      throw "Error encrypting data" + error;
    }

  }





  async dataD(data: any) {
    try {
      let k = en.temppa;
      // Robust quote stripping
      if (k.startsWith('"') || k.startsWith("'")) {
        k = k.substring(1, k.length - 1);
      }

      const pemString = k.split('\\n').join('\n');
      if (!pemString.includes('BEGIN RSA PRIVATE KEY') && !pemString.includes('BEGIN PRIVATE KEY')) {
        throw new Error("Invalid Private Key format. Key might still be encrypted or corrupted.");
      }

      const pK = forge.pki.privateKeyFromPem(pemString);

      const decoded = forge.util.decode64(data['data']);
      const chunks = JSON.parse(decoded);

      let decryptedBytes = '';

      for (let encryptedChunk of chunks) {
        const decryptedChunk = pK.decrypt(encryptedChunk, 'RSA-OAEP');
        decryptedBytes += decryptedChunk;
      }

      // Convert back from UTF-8
      const decryptedText = forge.util.decodeUtf8(decryptedBytes);

      if (data['error'] === false) {
        try {
          data['data'] = JSON.parse(decryptedText);
        } catch {
          data['data'] = decryptedText;
        }
      } else {
        data['data'] = decryptedText;
      }

      return data;
    } catch (error) {
      console.log("Error decrypting data", error);
      return error;
    }

  }


  token = "work@pcs";
  session = 'S@1';

  async tokenData() {
    return this.dataE(this.token)
  }


}
